import { Dialog, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AlertLinePageContainer = styled(Grid)({
  padding: "3% 15%",
  height: "97vh",
  overflow: "hidden",
});

export const Header = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  display: "flex",
  justifyContent: "space-between",
  padding: "20px",
  alignItems: "center",
  height: "70px",
}));

export const LandingContentContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "calc(100% - 115px)",
  overflow: "auto",
  "& > span": {
    whiteSpace: "pre-line",
  },
});

export const LandingContentActions = styled(Grid)({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
});

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
